
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {
  1: { // Exercise num
    unit: 'Unit 1',
    id: 'SB4-U1-P13-E1',
    audio: 'img/FriendsPlus/Page13/Audio/audio-e1-p13.mp3',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page13/E1/Key/answerKey.png',
    component: DesignUnderLine,
    totalInput: 3,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page13/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page13/Audio/tieude-e1-p13.mp3' },
        { url: 'img/FriendsPlus/Page13/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page13/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/5.jpg', audioUrl: 'img/FriendsPlus/Page13/Audio/hinh1-e1-p13.mp3' },
        { url: 'img/FriendsPlus/Page13/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/7.jpg', audioUrl: 'img/FriendsPlus/Page13/Audio/hinh2-e1-p13.mp3' },
        { url: 'img/FriendsPlus/Page13/E1/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page13/E1/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page13/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/11.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page13/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/13.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page13/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/15.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page13/E1/16.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page13/E1/17.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page13/E1/18.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/19.jpg', audioUrl: 'img/FriendsPlus/Page13/Audio/hinh3-e1-p13.mp3' },
        { url: 'img/FriendsPlus/Page13/E1/20.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/21.jpg', audioUrl: 'img/FriendsPlus/Page13/Audio/hinh4-e1-p13.mp3' },
        { url: 'img/FriendsPlus/Page13/E1/22.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page13/E1/23.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page13/E1/24.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/25.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page13/E1/26.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/27.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page13/E1/28.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/29.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page13/E1/30.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/31.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page13/E1/32.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/33.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page13/E1/34.jpg' },
        { url: 'img/FriendsPlus/Page13/E1/35.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page13/E1/36.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page13/E1/37.jpg' },
      ],


    ],
  },

  2: { // Exercise num
    unit: 'Unit 1',
    id: 'SB4-U1-P13-E2',
    audio: '',
    video: '',
    component: UI,
    questionImage: [ // Row
      [
        { url: 'img/FriendsPlus/Page13/E2/1.jpg' },

      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 1',
    id: 'SB4-U1-P13-E3',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter: true,
    exerciseKey: 'img/FriendsPlus/Page13/E3/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page13/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page13/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/3.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page13/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page13/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page13/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/7.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page13/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page13/E3/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page13/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/11.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page13/E3/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page13/E3/13.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page13/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page13/E3/15.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page13/E3/16.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page13/E3/17.jpg' },
      ],
    ],
  },
}

export default json;